import { useState } from 'react';
import { Rocket, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Container from '@/components/ui/Container';
import DashboardHeader from '@/components/dashboard/DashboardHeader';
import DashboardCard from '@/components/ui/DashboardCard';
import DatePill from '@/components/ui/DatePill';
import ProgressBar from '@/components/ui/ProgressBar';
import MembersList from '@/components/ui/MembersList';
import ViewDetailsButton from '@/components/ui/ViewDetailsButton';
import PageActions from '@/components/ui/PageActions';
import { FilterOption } from '@/components/ui/FilterDropdown';
import { PLACEHOLDER_PROJECTS } from '@/hooks/placeholder-data/placeholderData';

const Projects = () => {
  const navigate = useNavigate();
  // Use placeholder project data
  const projects = PLACEHOLDER_PROJECTS;
  
  // Filter options state
  const [filterOptions, setFilterOptions] = useState<FilterOption[]>([
    { id: 'active', label: 'Active', checked: false },
    { id: 'completed', label: 'Completed', checked: false },
    { id: 'delayed', label: 'Delayed', checked: false },
  ]);
  
  // Handle filter changes
  const handleFilterChange = (updatedOptions: FilterOption[]) => {
    setFilterOptions(updatedOptions);
  };
  
  // Navigate to project details page
  const handleProjectClick = (projectId: string) => {
    navigate(`/projects/${projectId}`);
  };
  
  return (
    <Container>
      <DashboardHeader 
        title="Projects"
        description="Manage and monitor all your ongoing client projects."
        icon={<Rocket size={24} />}
        primaryAction={{
          label: "Create",
          icon: Plus,
          onClick: () => console.log("Create new project")
        }}
      />
      
      <PageActions
        filterOptions={{
          options: filterOptions,
          onFilterChange: handleFilterChange,
          label: "Filters"
        }}
      />
      
      <div className="grid grid-cols-1 gap-6">
        {projects.map(project => (
          <DashboardCard 
            key={project.id} 
            className="p-6 relative overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.01]"
            onClick={() => handleProjectClick(project.id)}
          >
            <div className="flex justify-between items-start mb-6">
              <h3 className="font-bold text-xl bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                {project.name}
              </h3>
            </div>
            
            <p className="text-sm text-muted-foreground mb-6">{project.description}</p>
            
            <div className="mb-6">
              <ProgressBar progress={project.progress} />
            </div>
            
            <div className="flex justify-between items-center">
              <MembersList count={3} />
              <div className="flex items-center gap-3">
                <ViewDetailsButton onClick={() => handleProjectClick(project.id)} />
                <DatePill date={project.dueDate} />
              </div>
            </div>
          </DashboardCard>
        ))}
      </div>
    </Container>
  );
};

export default Projects; 